import {
  CONFIRM_ORDER,
  CANCEL_ORDER,
  SET_CURRENT_OPEN_TAB,
  SET_CURRENT_COMPLETED_TAB,
  GET_ACTIVE_LISTINGS,
  GET_PRODUCT_VARIANTS,
  GET_NEED_TO_CONFIRM_ORDERS,
  GET_NEED_TO_SHIP_ORDERS,
  GET_SHIPPED_ORDERS,
  GET_DELIVERED_ORDERS,
  GET_RETURNED_ORDERS,
  GET_CANCELED_ORDERS,
  GET_OPEN_ORDERS,
  GET_COMPLETED_ORDERS,
  UPDATE_PRODUCT_PRICE,
  RESET_STORE_PRICE,
  CLEAR_ACTIVE_LISTINGS_ERROR,
  LABEL_PRINTED,
} from 'store/constants/action-types';

export function confirmOrder(payload) {
  return { type: CONFIRM_ORDER, payload: payload };
}

export function cancelOrder(payload) {
  return { type: CANCEL_ORDER, payload: payload };
}

export function updateProductPrice(payload, page) {
  return { type: UPDATE_PRODUCT_PRICE, payload: payload, page: page };
}

export function resetToStorePrice(payload, page) {
  return { type: RESET_STORE_PRICE, payload: payload, page: page };
}

export function setCurrentOpenTabAction(payload) {
  return { type: SET_CURRENT_OPEN_TAB, payload: payload };
}

export function setCurrentCompletedTabAction(payload) {
  return { type: SET_CURRENT_COMPLETED_TAB, payload: payload };
}

export function getActiveListings(page) {
  return { type: GET_ACTIVE_LISTINGS, page: page };
}

export function getProductVariantsAction(ptId) {
  return { type: GET_PRODUCT_VARIANTS, id: ptId };
}

export function clearActiveListingsErrorAction() {
  return { type: CLEAR_ACTIVE_LISTINGS_ERROR };
}

export function labelPrintedAction(payload) {
  return { type: LABEL_PRINTED, payload: payload };
}

export const getOrdersAction = (tab, view, page) => {
  const searching = view === 'Active Listings' ? null : tab;
  switch (searching) {
    case 'confirm':
      return { type: GET_NEED_TO_CONFIRM_ORDERS, page: page };
    case 'toShip':
      return { type: GET_NEED_TO_SHIP_ORDERS, page: page };
    case 'shipped':
      return { type: GET_SHIPPED_ORDERS, page: page };
    case 'all':
      return view === 'Open'
        ? { type: GET_OPEN_ORDERS, page: page }
        : { type: GET_COMPLETED_ORDERS, page: page };
    case 'delivered':
      return { type: GET_DELIVERED_ORDERS, page: page };
    case 'returned':
      return { type: GET_RETURNED_ORDERS, page: page };
    case 'canceled':
      return { type: GET_CANCELED_ORDERS, page: page };
    default:
      return { type: GET_ACTIVE_LISTINGS, page: page };
  }
};
